import React, { useState } from "react";
import styled from "styled-components";

import Particle from "../Particle";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";

export default function Contact() {
  const [result, setResult] = useState("");

  const onSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending....");
    const formData = new FormData(event.target);

    formData.append("access_key", "2307e763-a09f-4f3d-8c41-5d93ecf9be01");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData,
    });

    const data = await response.json();

    if (data.success) {
      setResult("Form Submitted Successfully");
      event.target.reset();
    } else {
      console.log("Error", data);
      setResult(data.message);
    }
  };

  return (
    <Container>
      <Particle />
      <ContentWrapper>
        <div style={{paddingTop: "40px",}}>
          <DotLottieReact
            style={{
              width: "400px", 
              height: "400px", 
            }}
            src="https://lottie.host/4cbb31dd-2aa8-40f5-adfe-abccf525b2b8/1PEOB8uAq3.lottie"
            loop
            autoplay
          />
        </div>

        <StyledContactForm onSubmit={onSubmit}>
          <StyledInput
            type="text"
            name="name"
            placeholder="Your Name"
            required
          />
          <StyledInput
            type="email"
            name="email"
            placeholder="Your Email"
            required
          />
          <StyledTextarea name="message" placeholder="Your Message" required />
          <StyledButton type="submit">Submit Form</StyledButton>
          <ResultSpan>{result}</ResultSpan>
        </StyledContactForm>
      </ContentWrapper>
    </Container>
  );
}

const Container = styled.div`
  position: relative; /* Allows absolute positioning of children */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 5% auto;
  max-width: 1000px;
  padding: 20px;
  overflow: hidden;
  min-height: 80vh;
`;

const ContentWrapper = styled.div`
  position: relative; /* Ensure that the Particle component is positioned behind this wrapper */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media (min-width: 768px) {
    flex-direction: row;
  }
`;

const StyledContactForm = styled.form`
  flex: 1;
  width: 90%;
  padding: 20px;
  border-radius: 8px;
  padding-top: 10%;
  margin-top: 20px;

  @media (min-width: 768px) {
    margin-top: 0;
    margin-left: 5%;
  }
`;

const StyledInput = styled.input`
  width: 100%;
  height: 35px;
  padding: 7px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;

  &:focus {
    border-color: #007bff;
    outline: none;
  }
`;

const StyledTextarea = styled.textarea`
  width: 100%;
  height: 100px;
  padding: 7px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;

  &:focus {
    border-color: #007bf;
    outline: none;
  }
`;

const StyledButton = styled.button`
  width: 100%;
  padding: 10px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;

  &:hover {
    background-color: #0056b3;
  }
`;

const ResultSpan = styled.span`
  display: block;
  margin-top: 15px;
  font-size: 16px;
  color: #28a745;
`;
